import React, { useEffect, useState, useCallback } from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import * as MermaPartServices from "../../../../services/MermaPartService";
import * as CodeService from "../../../../services/CodeService";

import { useTranslation } from "react-i18next";
import MermaForm from "./mermaPartForm.view";
import PATHS from "../../../../constants/paths";
import {
  BreadCrumb,
  ShowAlertDialog,
} from "@de-prado-dev/react-component-library";

const MermaPartFormContainer = ({ uuid, onCancel, onSuccess }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [initValues, setInitValues] = useState({});
  const [codes, setCodes] = useState([]);
  const [tasks, setTasks] = useState([]);
  const [rows, setRows] = useState(0);

  const setInitialValues = useCallback(async (data, codes) => {
    const dataFinal = {
      codeUuid: data.codeUuid,
      initTime: data.initTime,
      endTime: data.endTime,
      numPlants: data.numPlants,
      rows: data.rows ? data.rows : [],
      comments: data.comments,
    };
    const dataCode = codes.find((cod) => cod.uuid === data.codeUuid);
    const rowsData = [];
    if (dataCode && dataCode.sector) {
      for (let index = 0; index < dataCode.sector.rows; index++) {
        rowsData.push({ value: index + 1, label: `Fila ${index + 1}` });
      }
    }
    setRows(rowsData);
    setInitValues(dataFinal);
  }, []);

  const loadData = useCallback(async () => {
    const resultCode = await CodeService.listAllCodes();
    if (resultCode) {
      setCodes(resultCode);
    }

    if (uuid) {
      const result = await MermaPartServices.getMermaPart(uuid);
      if (result) {
        await setInitialValues(result, resultCode);
      }
    }
  }, [setInitialValues, uuid]);

  useEffect(() => {
    loadData();
  }, []);

  const handleSubmit = async (values) => {
    try {
      if (values) {
        let result = undefined;

        if (uuid) {
          result = await MermaPartServices.updateMermaPart(values, uuid);
        } else {
          result = await MermaPartServices.addMermaPart(values);
        }

        let title = "";
        let text = "";
        let icon = "";
        if (result) {
          if (uuid) {
            title = t("forms.mermaPart.messages.update.title");
            text = t("forms.mermaPart.messages.update.success");
            icon = "success";
          } else {
            title = t("forms.mermaPart.messages.create.title");
            text = t("forms.mermaPart.messages.create.success");
            icon = "success";
          }
        } else {
          title = "Error";
          text = t("forms.mermaPart.messages.update.error");
          icon = "error";
        }

        let okAction = () => {
          onSuccess();
        };
        ShowAlertDialog(title, text, icon, false, "OK", false, okAction);
      }
    } catch (error) {
      //console.log('Error', error);
    }
  };

  const handlerOnChangeCode = (value) => {
    const rowsData = [];
    const dataCode = codes.find((cod) => cod.uuid === value);
    if (dataCode && dataCode.sector && dataCode.sector.rows > 0) {
      for (let index = 0; index < dataCode.sector.rows; index++) {
        rowsData.push({ value: index + 1, label: `Fila ${index + 1}` });
      }
    }
    setRows(rowsData);
  };

  return (
    <MermaForm
      codes={codes}
      rows={rows}
      edit={uuid ? true : false}
      initialValues={initValues}
      onSubmit={handleSubmit}
      onBack={onCancel}
      onChangeCode={handlerOnChangeCode}
    />
  );
};

MermaPartFormContainer.propTypes = {
  t: PropTypes.any,
};

export default MermaPartFormContainer;
